import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const resetRecordingExpiration = async ({ id }: { id: string }) => {
  const response = await axiosClient.post(`/recordings/${id}/reset-expiration`);
  return response.data;
};

export function useResetRecordingExpiration(
  queryOptions?: UseMutationOptions<void, HttpError, { id: string }>,
) {
  return useMutation({
    mutationFn: ({ id }) => resetRecordingExpiration({ id }),
    ...queryOptions,
  });
}
